import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { fmbaseUrl } from '../../../Constant/Matcher';



export const FMCPDetailApi = createApi({
    reducerPath: "FMCPDetailApi",
    baseQuery: fetchBaseQuery({baseUrl: `${fmbaseUrl}`}),
    endpoints: (builder) => ({
        clientDetail: builder.query({
            query: ({clientCode, cpid}) =>{
            
             let base = `clientlist?fmid=${clientCode}`
             if(cpid) base += `&cpid=${cpid}`
             return base
            },
            
         }),
        
    })
})

export const { useClientDetailQuery } = FMCPDetailApi